import FormView from '../../../../components/views/formView';
import { useFinalCausalityForm } from '../hook';
import { FinalCausalityData } from './data';
import { Grid } from '@mui/material';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';

export const FinalCausalityForm = () => {
    const {
        finalCausality,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikFinalCausalityData,
    } = useFinalCausalityForm();
    return (
        <>
            <FormView
                title={
                    finalCausality && finalCausality.id
                        ? 'Editar causalidad final'
                        : 'Crear causalidad final'
                }
            />
            <FinalCausalityData
                data={finalCausality}
                onChangeFormik={(formik) => setFormikFinalCausalityData(formik)}
                finalCausalityId={finalCausality?.id || ''}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
